import React, { useEffect, useState } from 'react';
import { format } from 'date-fns';
import VerifiedIcon from '../../../../../assets/verified-icon.svg';
import FoundingCreatorIcon from '../../../../../assets/founding_creator_icon.png';
import DefaultThumbnail from '../../../../../assets/default-thumnail.png';
import AvatarIcon from '../../../../../assets/medium_default_optimized.png';
import { useNavigate } from 'react-router-dom';
import SensitiveContentCard from '../../../../../components/SensitiveContentCard';

interface SmallWidgetArticleProps {
  article: any;
  profile: any;
  disabledNavigate?: boolean;
}

const SmallWidgetArticleComponent: React.FC<SmallWidgetArticleProps> = ({
  article,
  profile,
  disabledNavigate
}) => {
  const navigate = useNavigate();
  const [showSensitiveContentCard, setShowSensitiveContentCard] = useState(false);

  const handleNavigate = (url: string) => {
    if (disabledNavigate) return;
    navigate(url);
  };

  useEffect(() => {
    if (article?.moderation?.showWarning !== undefined) {
      setShowSensitiveContentCard(article.moderation.showWarning);
    }
  }, [article]);

  return (
    <div className="relative flex flex-col gap-2">
      {showSensitiveContentCard && !article?.isShowSensitive && (
        <div className="absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] z-10">
          <SensitiveContentCard
            actionButton={article?.moderation?.actionButton}
            primarySource={article?.moderation?.primarySource}
            primaryViolation={article?.moderation?.primaryViolation}
            setShowSensitiveContentCard={setShowSensitiveContentCard}
            articleId={article?.id}
            isShowSensitive={article?.isShowSensitive}
          />
        </div>
      )}
      <div
        className={`w-full grid grid-cols-[128px,auto] md:grid-cols-[165px,auto] gap-4 md:gap-[24px] ${showSensitiveContentCard && !article?.isShowSensitive ? 'blur-lg' : ''}`}
      >
        <div
          className="relative "
          onClick={() => handleNavigate(`/articles/${article?.alternativeId || article?.id}`)}
        >
          <img
            className="w-[128px] h-[128px] md:w-[165px] md:h-[100px] rounded-[8px] object-cover cursor-pointer"
            src={article?.cover || DefaultThumbnail}
            alt=""
          />
        </div>
        <div className="flex flex-col gap-[12px] 2xl:gap-[20px] w-full">
          <div className="flex flex-col md:gap-2">
            <div
              className="flex flex-wrap items-center gap-1 cursor-pointer"
              onClick={() => handleNavigate(`/${article?.creator?.username}`)}
            >
              <img
                src={article?.creator?.imgUrl || AvatarIcon}
                className="w-[24px] h-[24px] rounded-full flex-shrink-0 mr-1 object-cover"
              />
              <p className="font-[600] text-sm hover:text-growth-green-500 transition duration-200 truncate">
                {article?.creator?.firstName || ''}
              </p>
              {article?.creator?.isVerifiedAuthor && (
                <img src={VerifiedIcon} className="w-4 h-4" alt="" />
              )}
              {article?.creator?.isFoundingCreator && (
                <img
                  src={FoundingCreatorIcon}
                  className="w-4 h-4"
                  alt="Founding Creator"
                  title="Founding Creator"
                />
              )}
              {article?.creator?.username && (
                <span className="font-[600] text-xs text-02-dim-gray">
                  @{article?.creator?.username}
                </span>
              )}
              {article?.creator?.id === profile.id && (
                <div className="px-2 py-1 rounded-[80px] bg-growth-green-50 text-xs text-growth-green-900 font-[600]">
                  You
                </div>
              )}
            </div>
            <div className="flex items-center mt-4 md:mt-0">
              <p className="font-[600] whitespace-nowrap text-xs !text-02-dim-gray">
                {format(article?.createdAt || new Date(), 'dd MMM yyyy')}
              </p>
              <p className="font-[600] whitespace-nowrap ml-auto !text-02-dim-gray text-xs">
                {article?.readLength || '0 min'} read
              </p>
            </div>
            <h1
              className="font-[800] line-clamp-2 cursor-pointer hover:underline"
              onClick={() => handleNavigate(`/articles/${article?.alternativeId || article?.id}`)}
              title={article?.title}
            >
              {article?.title}
            </h1>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SmallWidgetArticleComponent;
